export default "__VITE_ASSET__Do_X7mep__"